export default __webpack_public_path__ + "static/media/sampleBigSmallMessageTopTicket.e4eb7e78.jpg";